import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { PermissaoService } from '../../core/services/permissao.service';

@Directive({
  selector: '[appTemPermissao]',
  standalone: true,
})
export class TemPermissaoDirective {
  private permissao?: string | string[];

  constructor(
    private readonly templateRef: TemplateRef<unknown>,
    private readonly viewContainer: ViewContainerRef,
    private readonly permissaoService: PermissaoService,
  ) {}

  @Input()
  set appTemPermissao(valor: string | string[]) {
    this.permissao = valor;
    this.atualizarVisibilidade();
  }

  private atualizarVisibilidade(): void {
    this.viewContainer.clear();

    if (!this.permissao) {
      return;
    }

    const permitido = Array.isArray(this.permissao)
      ? this.permissaoService.temAlgumaPermissao(this.permissao)
      : this.permissaoService.temPermissao(this.permissao);

    if (permitido) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}
